export const PHONE_NUMBER_FORM = {
  TITLE: "اهلا بك في وفي, ادخل رقم جوالك",
  SUB_TITLE: "سوف نقوم بتأكيد رقم جوالك للدخول الي حسابك",
  ERROR: "من فضلك ادخل رقمك الهاتفي الصحيح",
  WRONG_NUMBER: "رقم الهاتف غير صحيح",
};

export const OTP_FORM = {
  TITLE: "اهلا بك في وفي, ادخل رقم جوالك",
  SUB_TITLE: "ادخل رمز التحقيق, تم ارسال الرمز الي",
  CHANE_NUMBER: "تغيير الرقم",
  SEND_AGAIN: "اعادة الارسال خلال",
  TIME: "00.20",
  ERROR: "رمز التحقق غير صحيح, تأكد من الرمز المرسل و أعد ادخاله",
};
export const SECURITY_CODE_FORM = {
  TITLE: "اهلا بك في وفي, ادخل رقم جوالك",
  SUB_TITLE: "ادخل رمز الامان",
  ERROR: "رمز الامان غير صحيح",
};

export const LOGIN = "تسجيل الدخول";
export const CONFIRM = "تأكيد";
export const SKIP = "تخطي";

export const LOGIN_FORM_HEADERS = {
  TITLE: "تسجيل الدخول",
  SUB_TITLE: "ادخل معلوماتك الاساسية للدخول للوحة التحكم",
  EMAIL: "البريد الالكتروني",
  PASSWORD: "كلمة المرور",
  FORGET_PASSWORD: "نسيت كلمة المرور؟",
};
export const LOGIN_RESPONSE_ERROR =
  "خطأ في اسم المستخدم/البريد الالكتروني او كلمة السر";
